import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { i18n } from '../../translate/i18n';

function TailwickContactDrawerSkeleton() {
	return (
		<div className="tailwick-contact-drawer__scroll">
			<div className="tailwick-contact-drawer__profile card-body">
				<div className="tailwick-contact-drawer__skeleton-avatar" />
				<div className="tailwick-contact-drawer__skeleton-line tailwick-contact-drawer__skeleton-line--md" />
				<div className="tailwick-contact-drawer__skeleton-line tailwick-contact-drawer__skeleton-line--sm" />
				<div className="tailwick-contact-drawer__skeleton-line tailwick-contact-drawer__skeleton-line--btn" />
			</div>
			<div className="tailwick-contact-drawer__sections card-body">
				<div className="tailwick-contact-drawer__skeleton-block">
					<div className="tailwick-contact-drawer__skeleton-line tailwick-contact-drawer__skeleton-line--title" />
					<div className="tailwick-contact-drawer__skeleton-line" />
				</div>
				<div className="tailwick-contact-drawer__skeleton-block">
					<div className="tailwick-contact-drawer__skeleton-line tailwick-contact-drawer__skeleton-line--title" />
					<div className="tailwick-contact-drawer__skeleton-line" />
				</div>
			</div>
		</div>
	);
}

function ContactDrawerSkeleton({ classes, tailwickLayout = false }) {
	if (tailwickLayout) {
		return <TailwickContactDrawerSkeleton />;
	}

	return (
		<div className={classes.content}>
			<Paper square variant="outlined" className={classes.contactHeader}>
				<Skeleton
					animation="wave"
					variant="circle"
					width={160}
					height={160}
					className={classes.contactAvatar}
				/>
				<Skeleton animation="wave" height={25} width={90} />
				<Skeleton animation="wave" height={25} width={80} />
				<Skeleton animation="wave" height={25} width={80} />
			</Paper>
			<Paper square className={classes.contactDetails}>
				<Typography variant="subtitle1">
					{i18n.t('contactDrawer.extraInfo')}
				</Typography>
				<Paper square variant="outlined" className={classes.contactExtraInfo}>
					<Skeleton animation="wave" height={20} width={60} />
					<Skeleton animation="wave" height={20} width={160} />
				</Paper>
				<Paper square variant="outlined" className={classes.contactExtraInfo}>
					<Skeleton animation="wave" height={20} width={60} />
					<Skeleton animation="wave" height={20} width={160} />
				</Paper>
				<Paper square variant="outlined" className={classes.contactExtraInfo}>
					<Skeleton animation="wave" height={20} width={60} />
					<Skeleton animation="wave" height={20} width={160} />
				</Paper>
			</Paper>
		</div>
	);
}

export default ContactDrawerSkeleton;
